import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Layout from "./layout/Layout";

ReactDOM.render(
    <React.StrictMode>
        <Layout />
    </React.StrictMode>,
    document.getElementById('root')
);